var CASA_FEATURES;
(function (CASA_FEATURES) {
    CASA_FEATURES["SGT_CASA"] = "SGT_CASA";
    CASA_FEATURES["VT_CASA"] = "VT_CASA";
    CASA_FEATURES["WIDGET_CASA"] = "Widget_CASA";
})(CASA_FEATURES || (CASA_FEATURES = {}));

export { CASA_FEATURES };
